module.exports = __webpack_public_path__ + "img/apostol-1566-prima-pagina-big.bb1400f2.png";